// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-1b668458]{display:flex;flex-shrink:0;align-items:center;border:1px solid #afbec7;border-radius:10px;font-size:11px}.label--body[data-v-1b668458]{margin:0;line-height:15px;padding:2px 10px}", ""]);
// Exports
module.exports = exports;
